__turbopack_context__.v({
  "contentWrp": "modalContent-module-scss-module__7Gf-0a__contentWrp",
  "isVisible": "modalContent-module-scss-module__7Gf-0a__isVisible",
  "modalMobileFooterLayout": "modalContent-module-scss-module__7Gf-0a__modalMobileFooterLayout",
  "modalMobileFooterLayoutWrp": "modalContent-module-scss-module__7Gf-0a__modalMobileFooterLayoutWrp",
  "preloaderSpinnerOverlay": "modalContent-module-scss-module__7Gf-0a__preloaderSpinnerOverlay",
});
